import React, { useState, useEffect } from 'react';

const CategorySelector = ({ label, categories, initialSelected = [], onSelectionChange }) => {
  const [selectedItems, setSelectedItems] = useState(initialSelected);

  // Update selectedItems when initialSelected changes
  useEffect(() => {
    setSelectedItems(initialSelected);
  }, [initialSelected]);

  const handleCheckboxChange = (category) => {
    const newSelectedItems = selectedItems.includes(category)
      ? selectedItems.filter(item => item !== category)
      : [...selectedItems, category];
    
    setSelectedItems(newSelectedItems);
    onSelectionChange?.(newSelectedItems);
  };

  return (
    <div className="w-full">
      <label className="block mb-2 text-sm font-medium text-gray-700">
        {label}
      </label>
      
      <div className="w-full p-4 bg-white border border-gray-200 rounded-lg space-y-2">
        {categories.map((category) => (
          <label 
            key={category}
            className="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer"
          >
            <input
              type="checkbox"
              className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
              checked={selectedItems.includes(category)}
              onChange={() => handleCheckboxChange(category)}
            />
            <span className="ml-2 text-sm text-gray-700">{category}</span>
          </label>
        ))}
      </div>

      {selectedItems.length > 0 && (
        <div className="mt-4">
          <div className="text-sm text-gray-500 mb-2">Selected services:</div>
          <div className="flex flex-wrap gap-2">
            {selectedItems.map((item) => (
              <div 
                key={item}
                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800"
              >
                {item}
                <button
                  type="button"
                  className="ml-1.5 inline-flex items-center justify-center w-4 h-4 text-indigo-400 hover:text-indigo-600"
                  onClick={() => handleCheckboxChange(item)}
                >
                  <span className="sr-only">Remove</span>
                  ×
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategorySelector;